import { render, staticRenderFns } from "./FooterCardapio.vue?vue&type=template&id=fd829a84"
import script from "./FooterCardapio.vue?vue&type=script&lang=js"
export * from "./FooterCardapio.vue?vue&type=script&lang=js"
import style0 from "./FooterCardapio.vue?vue&type=style&index=0&id=fd829a84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports